/**
 * FaturamentoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Faturamento} from '@/model/resource/Faturamento'

/* TODO: review generated class */
@HttpExclude()
export class FaturamentoCollection extends PageCollection<Faturamento> {
  constructor() {
    super(Faturamento)
  }

  queryAsPage() {
    return this.listFaturamento()
  }

  async listFaturamento() {
    return await Request.get(`/admin/faturamento`, {params: this.params})
      .name('listFaturamento')
      .as(this)
      .getResponse()
  }

  async listCsvFaturamento() {
    return await Request.get(`/admin/faturamento/csv`, {params: this.params})
      .name('listCsvFaturamento')
      .as(this)
      .getResponse()
  }
}
